import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "@/assets/css/fonts.css"
import "@/assets/css/tailwind.css"

const app = createApp(App)
.use(router);

app.directive('focus', {
  mounted(el, binding) {
    if (binding.value === undefined || binding.value) {
      el.focus();
    }
  },
});

app.mount('#app');
